export default __webpack_public_path__ + "static/media/rentals.32fcd2b1.svg";